export const captchaSiteKey = () => {
    const miljo = window.location.hostname;

    if (miljo.includes('utv.vegvesen.no'))
        return '6LemFikTAAAAAIDt2Dy0mZaFa2jbnC6ZEPXv08rX';
    if (miljo.includes('test.vegvesen.no'))
        return '6Lc1VQ8UAAAAAErBftWB9nehGAw7KMyrHOtnEiQq';
    if (miljo.includes('vegvesen.no'))
        return '6LeFUQ8UAAAAAE6iCLDfbxr3ThYMAdDhQNbAkJeu';

    throw new Error('Feil ved å sette captchaSiteKey');
};
